/**
 * @class
 * https://kb.netx.net/pages/viewpage.action?spaceKey=ND&title=NetX+Support+Saml
 */
import Base from '@netx/core/lib/netx-model';

class SAMLService extends Base {
	/**
	 * @property {object}  defaults              - Model defaults
	 * @property {string}  defaults.description  - Service description
	 * @property {string}  defaults.label        - Service label
	 * @property {string}  defaults.name         - Service name
	 * @property {string}  defaults.type         - Service type
	 */
	get defaults() {
		return {
			description: '',
			label: '',
			name: '',
			type: '',
		};
	}

	/** @type {string} */
	get idAttributes() {
		return 'name';
	}

	/** @type {string} */
	static get __name__() {
		return 'SAMLService';
	}
}

export default SAMLService;
